// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eL5O","colMin":"styles_colMin__2XGjS"};